module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/285.37a929aa.png";